import React, { createContext, useMemo } from "react";

import useAuth from "../../hooks/useAuth.js";
import useBillingStatus from "../../hooks/useBillingStatus";
import { isBillingRestricted } from "../../utils/billing";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const { loading, loadingScreen, splashVisible, user, isAuth, handleLogin, handleLogout } = useAuth();
	const { billing, billingLoading, billingError, refreshBilling } = useBillingStatus({ isAuth, user });
	const isCompanyRestricted = isBillingRestricted(user, billing);

	// Memoiza o valor do context para evitar re-renders desnecessários
	const contextValue = useMemo(() => ({
		loading,
		loadingScreen,
		splashVisible,
		user,
		isAuth,
		handleLogin,
		handleLogout,
		billing,
		billingLoading,
		billingError,
		refreshBilling,
		isCompanyRestricted
	}), [loading, loadingScreen, splashVisible, user, isAuth, handleLogin, handleLogout, billing, billingLoading, billingError, refreshBilling, isCompanyRestricted]);

	return (
		<AuthContext.Provider value={contextValue}>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
